import { useEffect, useState } from 'react';
import { apiFetch } from '../lib/api';

// 物流定性字典 hook（shipping-zones v2）
// 供 AdminProducts 注入下拉與 AdminShipping 勾選區共用；模組級 60s 快取防多處重複請求。

export interface ShippingNature {
  id: number;
  code: string;
  nameZh: string;
  sort: number;
}

let cache: { at: number; data: ShippingNature[] } | null = null;
let inflight: Promise<ShippingNature[]> | null = null;

export function fetchShippingNatures(force = false): Promise<ShippingNature[]> {
  if (!force && cache && Date.now() - cache.at < 60_000) return Promise.resolve(cache.data);
  if (!force && inflight) return inflight;
  inflight = apiFetch('/api/public/shipping/natures')
    .then((res) => res.json())
    .then((json) => {
      const list: ShippingNature[] = Array.isArray(json) ? json : json?.data || [];
      cache = { at: Date.now(), data: list };
      inflight = null;
      return list;
    })
    .catch(() => {
      inflight = null;
      return cache?.data || [];
    });
  return inflight;
}

export function useShippingNatures(): { natures: ShippingNature[]; loading: boolean } {
  const [natures, setNatures] = useState<ShippingNature[]>(cache?.data || []);
  const [loading, setLoading] = useState(!cache);
  useEffect(() => {
    let alive = true;
    fetchShippingNatures().then((list) => {
      if (alive) { setNatures(list); setLoading(false); }
    });
    return () => { alive = false; };
  }, []);
  return { natures, loading };
}
